import { createVNode } from 'vue'
import { defineStore } from 'pinia'
import { store } from '../index'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useI18n } from '@/hooks/web/useI18n'
import { useTagsViewStore } from './tagsView'
import { usePermissionStore } from './permission'
import { useProductStore } from './product'
import { useStorage } from '@/hooks/web/useStorage'

export const useUserStore = defineStore('user', {
  state: (): { [key: string]: any } => {
    return {
      userInfo: undefined,
      tokenKey: 'Authorization',
      token: '',
      roleRouters: undefined,
      // 记住我
      rememberMe: false,
      loginInfo: undefined
    }
  },
  getters: {
    getTokenKey(): string {
      return this.tokenKey
    },
    getToken(): string {
      return this.token
    },
    getUserInfo(): { [key: string]: any } | undefined {
      return this.userInfo
    },
    getRoleRouters(): { [key: string]: any } | undefined {
      return this.roleRouters
    },
    getRememberMe(): boolean {
      return this.rememberMe
    },
    getLoginInfo(): { [key: string]: any } | undefined {
      return this.loginInfo
    },
    getMemberStatus(): number {
      // 1 是会员 2 有次数 3 没得次数
      return this.userInfo.times ? 2 : 1
    }
  },
  actions: {
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey
    },
    setToken(token: string) {
      this.token = token
    },
    setUserInfo(userInfo: { [key: string]: any } | undefined) {
      this.userInfo = userInfo
    },
    setUserInfoAndToken(data: { [key: string]: any }) {
      this.token = data.token
      this.userInfo = data.user
    },
    setRoleRouters(roleRouters: { [key: string]: any } | undefined) {
      this.roleRouters = roleRouters
    },
    setCredit(credit: number) {
      this.userInfo.times = credit
    },
    logoutConfirm() {
      const { t } = useI18n()
      Modal.confirm({
        title: t('common.reminder'),
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode('div', {}, t('common.loginOutMessage')),
        okText: t('common.ok'),
        cancelText: t('common.cancel'),
        class: 'logoutModal',
        onOk: () => {
          this.reset()
        },
        onCancel() {
          console.log('Cancel')
        }
      })
    },
    async reset() {
      const tagsViewStore = useTagsViewStore()
      tagsViewStore.delAllViews()
      const permissionStore = usePermissionStore()
      permissionStore.clearPermissionStore()
      const productStore = useProductStore()
      productStore.clearProductStore()
      const { removeStorage } = useStorage('localStorage')
      removeStorage('releaseFormState')
      this.setToken('')
      this.setUserInfo(undefined)
      this.setRoleRouters([])
      const router = (await import('@/router')).default
      router.replace('/login')
    },
    logout() {
      this.reset()
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe
    },
    setLoginInfo(loginInfo: { [key: string]: any } | undefined) {
      this.loginInfo = loginInfo
    },
    consumptionUsageTimes() {
      this.userInfo.times--
    }
  },
  persist: true
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
